import React from 'react'

import { FeatureBadge, FeatureTooltip, Text } from '@driftt/dds'

import useShowTooltip from '../useShowTooltip.hook'

const InformationalTooltip = ({ children }) => {
  const { neverShowTooltip, patchTooltipProperty, isValidating } =
    useShowTooltip()

  return (
    <FeatureTooltip.Root
      open={!isValidating && !neverShowTooltip}
      onOpenChange={() => patchTooltipProperty()}
    >
      <FeatureTooltip.Trigger>{children}</FeatureTooltip.Trigger>
      <FeatureTooltip.Content
        css={{ width: 336 }}
        side="top"
        avoidCollisions={false}
        orientation="horizontal"
      >
        <FeatureBadge variant="new" bolt />
        <FeatureTooltip.ContentHeader>
          Now you can edit name and teams from the Sales Rep setup report!
        </FeatureTooltip.ContentHeader>
        <Text>
          To add or edit a user's name or team, click on their name or the edit
          icon in this row.
        </Text>
      </FeatureTooltip.Content>
    </FeatureTooltip.Root>
  )
}

export default InformationalTooltip
